import React, { Component } from 'react';
import { func } from 'prop-types';
import { translate } from 'react-i18next';
import ReactMarkdown from 'react-markdown';

import Accordion from '@dragonfruit/components/Accordion';

import styles from './PurchaseFAQ.scss';

class PurchaseFAQ extends Component {
  static propTypes = {
    t: func.isRequired,
  };

  state = {
    selectedFaq: '',
  };

  handleSelectFaq = value => {
    const selectedFaq = this.state.selectedFaq === value ? '' : value;

    this.setState({
      selectedFaq,
    });
  };

  render() {
    const { t } = this.props;

    const { selectedFaq } = this.state;

    const questions = t('purchase.faq.questions', {
      returnObjects: true,
      defaultValue: [],
    });

    const finalQuestions = questions.filter(({ a }) => a && a !== '-');

    return (
      <div>
        <h4 className={styles.title}>{t('purchase.faq.title')}</h4>
        <Accordion>
          {finalQuestions.map((question, index) => {
            const { q, a, link } = question;

            return (
              <Accordion.Tab
                key={index}
                label={q}
                value={link}
                onClick={this.handleSelectFaq}
                selected={selectedFaq === question.link}
              >
                <ReactMarkdown source={a} />
              </Accordion.Tab>
            );
          })}
        </Accordion>
      </div>
    );
  }
}

export default translate(['purchase'])(PurchaseFAQ);



// WEBPACK FOOTER //
// ./app/components/PurchaseFAQ/PurchaseFAQ.jsx